<template>
	<button type="button" @click="onClickSearch"><IconSearch /><span>{{ $t('search.button') }}</span></button>
</template>

<script>
	import IconSearch from "@/components/icons/IconSearch"

	export default {
		components: {
			IconSearch
		},
		methods: {
			onClickSearch() {
				this.$modal.show("search-local");
			},
			keydownEvent(e) {
				if (e.srcElement.tagName === "INPUT" || e.srcElement.tagName === "TEXTAREA") return;
				if (e.code === "KeyF") {
					this.onClickSearch();
				}
			},
		},
		mounted() {
			document.addEventListener("keyup", this.keydownEvent);
		},
		destroyed() {
			document.removeEventListener("keyup", this.keydownEvent);
		}

	}

</script>

<style lang="scss" scoped>
	.icon-search {
		width: 20px;
		margin: 4px 0 0 -5px;
		float: left;
		position: absolute;
	}

	span {
		margin-left: 22px;
		float: left;

		@media only screen and (max-width: 1070px) {
			font-size: 0;
			margin-left: 10px;
		}
	}


</style>
